export default "__VITE_ASSET__BC_Gd6RQ__"